import React from "react";
import Grafics from "../../Img/grapphics.png";
import OraclePartner from "../../Img/oracle.png";
import IncImg from "../../Img/inc.png";
import IsoImg from "../../Img/iso.png";
import SocImg from "../../Img/soc.png";
import BuildingImg from "../../Img/Building.png";
const Footer = () => {
  return (
    //   <div className='d-flex' style={{ background: '#2d2b2b',minHeight:'5vh'}}>
    //    <h6 className="text-end text-white w-100 mx-2 mb-0" style={{fontSize:'1.5vh'}}>Camptra Knowledge Repository - Designed by Silfra Technologies
    //    </h6>
    //   </div>

    <>
      <div className="row footer-main-div g-0">
        <div className="col-lg-1 col-sm-1">
          <div className="">
            <img
              style={{ height: "60px", paddingRight: "5rem" }}
              className="w-100 "
              src={Grafics}
              alt=""
            />
          </div>
        </div>
        <div className="col-lg-5 col-sm-8">
          <div className="footerImg blue-border footerText">
            <p className="fw-bold dynamic-sol-class text-center">
              DYNAMIC SOLUTIONS, TRUSTED SERVICE
            </p>
          </div>
        </div>

        <div className="col-lg-2  col-sm-3">
          <div className="footerImg footerOraclePartnerImg">
            <img className="oracle-partner-img" src={OraclePartner} alt="" />
          </div>
        </div>
        <div className="col-lg-1 col-sm-2">
          <div className="footerImg footerIncImg">
            <img className="inc-img" src={IncImg} alt="" />
          </div>
        </div>
        <div className="col-lg-1 col-sm-2">
          <div className="footerImg footerIsoImg">
            <img className="iso-img" src={IsoImg} alt="" />
          </div>
        </div>
        <div className="col-lg-1 col-sm-2">
          <div className="footerImg footerImgSoc">
            <img className="soc-img " src={SocImg} alt="" />
          </div>
        </div>
        {/* <div className="col-lg-1 col-sm-2">
          <div className="footerImg footerBuildingImg">
            <img className="w-100 ps-4" src={BuildingImg} alt="" />
          </div>
        </div> */}
      </div>
    </>
  );
};

export default Footer;
